import { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { BroadcastMessage } from './api'

/**
 * The email as a broker would read it: its three headers, and its body either formatted or
 * as the plain text a mail client falls back to. The HTML is drawn in a sandboxed frame —
 * no scripts, no forms, no reach into the portal — because a person typed part of it (the
 * posting's special instructions), however carefully the server encoded it.
 */
export function MessagePreview({ message }: { message: BroadcastMessage }) {
  const { t } = useTranslation()
  const [asText, setAsText] = useState(false)
  const headingId = useId()

  return (
    <section className="broadcast-section broadcast-message" aria-labelledby={headingId}>
      <h2 id={headingId}>{t('broadcasts.message.title')}</h2>
      <dl className="broadcast-message__headers">
        <dt>{t('broadcasts.message.from')}</dt>
        <dd>{`${message.fromName} <${message.fromAddress}>`}</dd>
        <dt>{t('broadcasts.message.replyTo')}</dt>
        <dd>{message.replyTo}</dd>
        <dt>{t('broadcasts.message.subject')}</dt>
        <dd>{message.subject}</dd>
      </dl>
      <div className="broadcast-message__switch" role="group" aria-label={t('broadcasts.message.view')}>
        <button type="button" className="button button--quiet" aria-pressed={!asText} onClick={() => setAsText(false)}>
          {t('broadcasts.message.formatted')}
        </button>
        <button type="button" className="button button--quiet" aria-pressed={asText} onClick={() => setAsText(true)}>
          {t('broadcasts.message.plainText')}
        </button>
      </div>
      {asText ? (
        <pre className="broadcast-message__text">{message.textBody}</pre>
      ) : (
        <iframe
          className="broadcast-message__frame"
          title={t('broadcasts.message.frameTitle')}
          sandbox=""
          srcDoc={message.htmlBody}
        />
      )}
    </section>
  )
}
